// Layout breakpoints (px)
export const PHONE = 480;
export const MOBILE = 768;
export const TABLET = 1000;
export const REC_PANEL_BREAKPOINT = 1400;
